import {annualEventConfirmation} from "../../../components/annualEventConfirmation";
import React from "react";
import { Button as AntButton, Result, Spin } from "antd";
import Meta from "../Meta";
import Loader from "../loader";
import PageHeader from "../components/PageHeader";
import FormEditorRender from "../../../components/WebEditor/form";
import FormMultiDevise from "../../../components/FormMultiDevise";
import { applyI18n } from "../../../i18n";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import { resolveImage } from "../utils";
import {isMobile} from "react-device-detect";

const styles = `

`;

export default class FormPage extends React.Component {
    state = { submit: false, loading: true, formData: null, accessId: null };

    componentDidMount() {
        this.setState({ loading: false });
        const context = this.props.context;
        const accessId = context.query?.accessId || context.query?.a;
        if (accessId) this.setState({ accessId });
    }

    submitRender() {
        return (
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", marginTop: 60 }}>
                <Result
                    status="success"
                    title={t`Votre formulaire a bien été reçu.`}
                    subTitle={<>{annualEventConfirmation(this.props.context.data?.[0], this.props.context) && <p style={{whiteSpace:"pre-line"}}>{annualEventConfirmation(this.props.context.data?.[0], this.props.context)}</p>}{this.state.ticketsUrl ? t`Vos billets sont prêts : présentez-les à l'entrée.` : t`Il sera traité dans les meilleurs délais.`}</>}
                    extra={[
                        // Billets émis à la validation : lien vers la page « mes billets ».
                        this.state.ticketsUrl && <AntButton key="tickets" type="primary" href={this.state.ticketsUrl}><Trans>Voir mes billets</Trans></AntButton>,
                        <AntButton key="reset" type={this.state.ticketsUrl ? "default" : "primary"} onClick={() => window.location.reload()}>
                            <Trans>Soumettre un nouveau formulaire</Trans>
                        </AntButton>,
                    ].filter(Boolean)}
                />
            </div>
        );
    }

    render() {
        const context = this.props.context;
        const { org, data } = context;

        if (!data || data.length === 0) {
            return (
                <>
                    <Meta context={context} title={t`Formulaire`} noindex />
                    <div style={{ padding: 60, textAlign: "center", color: "var(--ink-3)" }}>
                        <Trans>Ce formulaire est introuvable.</Trans>
                    </div>
                </>
            );
        }

        const form = applyI18n(data[0], context);
        if (form.products) form.products = form.products.map(p => applyI18n(p, context));

        let lang = context.langValue;
        const languages = org.languages || [];
        if (languages.length > 0 && !lang) lang = org.language;

        const title = form.title;
        const description = form.description;
        const metaTitle = form.metaTitle || title;
        const metaDescription = form.metaDescription || description;
        const metaImage = form.metaImage ? resolveImage(form.metaImage) : null;

        const extra = {};
        if (this.state.accessId) extra.accessId = this.state.accessId;
        if (org.virtualId) extra.virtualId = org.virtualId;

        const isActive = !(!form.active || form.expired || (form.expireAt && new Date(form.expireAt).getTime() < Date.now()));

        if (this.props.loading) {
            return (
                <>
                    <Meta context={context} seo={form} title={metaTitle} description={metaDescription} image={metaImage} />
                    <Loader />
                </>
            );
        }

        return (
            <>
                <Meta context={context} seo={form} title={metaTitle} description={metaDescription} image={metaImage} />
                <style dangerouslySetInnerHTML={{ __html: styles }} />

                {context.render !== "embed" && title && (
                    <PageHeader title={title} subtitle={description} />
                )}

                {isActive ? (
                    <div>
                        <FormMultiDevise context={context} form={form} />
                        <Spin spinning={this.state.loading}>
                            <div style={context.render !== "embed" ? { marginTop: 20, minHeight: "50vh" } : undefined}>
                                {!this.state.submit && (
                                    <FormEditorRender
                                        form={form}
                                        lang={lang}
                                        onLoading={(loading) => this.setState({ loading })}
                                        onSubmit={(formData, result) => this.setState({ loading: false, submit: true, formData, ticketsUrl: result?.ticketsUrl || null })}
                                        extra={Object.keys(extra).length > 0 ? extra : null}
                                        org={org}
                                        isMobile={context.isMobile}
                                    />
                                )}
                                {this.state.submit && this.submitRender()}
                            </div>
                        </Spin>
                    </div>
                ) : (
                    <div style={{ minHeight: "40vh", display: "flex", justifyContent: "center", alignItems: "center", padding: 20 }}>
                        <Result
                            style={{ maxWidth: 600 }}
                            status="warning"
                            title={t`Ce formulaire est expiré !`}
                            subTitle={t`Vous ne pouvez pas remplir ce formulaire pour le moment. Contactez votre responsable.`}
                            extra={context.render !== "embed" ? (
                                <AntButton href={org.BASE_WEB_URL}><Trans>Retourner à la page d'accueil</Trans></AntButton>
                            ) : undefined}
                        />
                    </div>
                )}
            </>
        );
    }
}
